// Visibility rules for the in-app feedback / "Report a Bug" tool (Task 24733).
//
// The tool started life as a developer-only shortcut gated on
// User.FlagDeveloper. It is now offered to every staff member and customer
// user across every company, with two opt-outs:
//
//   * company level - an admin turns it off for the whole company
//   * staff level   - an individual turns it off just for themselves
//
// Both are the one MasterConfigItem, resolved by the usual three-tier
// hierarchy (MasterConfigItem -> ConfigCompany -> ConfigUser) and delivered to
// the client at login inside authUser.get_configitem_data as ZCONFIGVAL_56_X.
//
// WHY A WORD AND NOT 0/1: the config resolver treats '0' as unset
// (PHP empty('0') === true) and configuser/append flatly REFUSES an empty
// ConfigUser_Value, so a staff member who turned the tool off with a '0'/'1'
// flag could never turn it back on - there would be no way to write the "on"
// value. Both states therefore carry a non-empty word.
//
// Company "off" also clears ConfigCompany.FlagAllowUserOverride, so a company
// that switches the tool off cannot have individual staff switch it back on;
// with the company "on", a staff 'hide' wins for that one user.
export const FEEDBACK_TOOL_CONFIG_ID = 56;
export const FEEDBACK_TOOL_CONFIG_KEY = "ZCONFIGVAL_56_X";

export const FEEDBACK_TOOL_SHOW = "show";
export const FEEDBACK_TOOL_HIDE = "hide";

const readAuthUser = () => {
  try {
    return JSON.parse(localStorage.getItem("authUser") || "{}") || {};
  } catch (e) {
    return {};
  }
};

// The resolved mode for the signed-in user. Anything that is not an explicit
// 'hide' means shown, so a company with no row seeded yet still gets the tool
// (the requirement is "on by default").
export const readFeedbackToolMode = () => {
  const value = readAuthUser()?.get_configitem_data?.[FEEDBACK_TOOL_CONFIG_KEY];
  return String(value || "").toLowerCase() === FEEDBACK_TOOL_HIDE
    ? FEEDBACK_TOOL_HIDE
    : FEEDBACK_TOOL_SHOW;
};

export const isFeedbackToolVisible = () =>
  readFeedbackToolMode() !== FEEDBACK_TOOL_HIDE;

// Keep localStorage in step after a toggle so the button appears/disappears
// immediately instead of waiting for the next login (get_configitem_data is
// only rebuilt at login / company switch).
export const patchFeedbackToolMode = (mode) => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser")) || {};
    authUser.get_configitem_data = {
      ...(authUser.get_configitem_data || {}),
      [FEEDBACK_TOOL_CONFIG_KEY]: mode,
    };
    localStorage.setItem("authUser", JSON.stringify(authUser));
  } catch (e) {
    /* localStorage unavailable - the value still resolves on next login */
  }
};

// User.FlagDeveloper, read the same way everywhere. The developer-only parts of
// the report form (Let AI handle this / Issue Type / Area Affected) hang off
// this: a customer filling in a bug report has no idea whether something is a
// "Prototype" or whether the backend is involved, so they only get Title,
// Description, Severity and the screenshot tools.
// Task 24761 - now defined in helpers/functions/developerFlag and re-exported
// here so the existing feedback call sites keep working off one definition.
export { isDeveloperUser } from "./developerFlag";
